<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">币安合约</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>合约统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 10px">
            <el-tab-pane label="母账户余额" name="PARENT_ACCOUNT_BALANCE"></el-tab-pane>
            <el-tab-pane label="手续费返佣统计" name="STATISTICS_RETURNED_COMMISSION"></el-tab-pane>
            <el-tab-pane label="合约余额快照查询" name="CONTRACT_BALANCE_SNAPSHOT"></el-tab-pane>
            <el-tab-pane label="合约交易数据" name="CONTRACT_TRADE_DATA"></el-tab-pane>
        </el-tabs>

        <!--母账户余额-->
        <div v-if="activeName=='PARENT_ACCOUNT_BALANCE'">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="mDataList" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="coinAmount" label="可用余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="coinFroze" label="冻结余额" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

        <!--手续费返佣统计-->
        <div v-if="activeName=='STATISTICS_RETURNED_COMMISSION'">
            <el-date-picker v-model="timeArr" type="datetimerange" value-format="timestamp" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

            <el-button type="primary" @click="commissionRebateCount">搜 索</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="cDataList" :row-key="() => Math.random()">
                <el-table-column prop="subaccountId" label="子账号id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="income" label="返佣" show-overflow-tooltip></el-table-column>
                <el-table-column prop="asset" label="币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tradeId" label="交易ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rebateTime" label="返佣时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

        <!--合约余额快照查询-->
        <div v-if="activeName=='CONTRACT_BALANCE_SNAPSHOT'">
            <el-input v-model="bParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            <el-input v-model="bParams.coinType" placeholder="币种" style="width: 300px"></el-input>
            <el-date-picker v-model="bParams.snapshotTime" type="datetime" value-format="timestamp"
                            placeholder="快照时间"></el-date-picker>
            <el-button type="primary" @click="balanceSnapshot">搜 索</el-button>
            <el-button type="primary" @click="exportBalanceSnapshot">导 出</el-button>
            <el-button type="primary" @click="balanceSnapshotCount">子账户余额快照统计</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="bDataList" :row-key="() => Math.random()">
                <el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subAccountId" label="子账户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="coinType" label="币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalAmount" label="账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossWalletBalance" label="全仓账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossUnPnl" label="全仓持仓未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="availableBalance" label="可用下单余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="withdrawAvailable" label="最大可转出余额(最大可提款金额)"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="snapshotTime" label="快照时间" show-overflow-tooltip></el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="bParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="bParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="bTotal">
            </el-pagination>
        </div>

        <!--合约交易数据查询-->
        <div v-if="activeName=='CONTRACT_TRADE_DATA'">
            <el-date-picker v-model="timeArrOne" type="datetimerange" value-format="timestamp" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input v-model="tParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            <el-input v-model="tParams.orderId" placeholder="订单ID" style="width: 300px"></el-input>
            <el-input v-model="tParams.symbol" placeholder="交易对" style="width: 300px"></el-input>
            <el-button type="primary" @click="contractTradeData">搜 索</el-button>
            <el-button type="primary" @click="exportContractTradeData">导 出</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="tDataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderId" label="订单编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subAccountId" label="子账号ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pair" label="标的交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="buyer" label="是否是买方" show-overflow-tooltip></el-table-column>
                <el-table-column prop="commission" label="手续费" show-overflow-tooltip></el-table-column>
                <el-table-column prop="commissionAsset" label="手续费计价单位" show-overflow-tooltip></el-table-column>
                <el-table-column prop="marginAsset" label="保证金币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maker" label="是否是挂单方" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="成交价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="qty" label="成交量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="quoteQty" label="成交额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="realizedPnl" label="实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="side" label="买卖方向" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionSide" label="持仓方向" show-overflow-tooltip></el-table-column>
                <el-table-column prop="time" label="交易时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.time | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChangeOne"
                           @current-change="handleCurrentChangeOne"
                           :current-page="tParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="tParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tTotal">
            </el-pagination>
        </div>

        <el-dialog title="子账户余额快照统计" :visible.sync="dialogVisible" width="80%" @close="clearData">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="sDataList" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalAmount" label="账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossWalletBalance" label="全仓账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossUnPnl" label="全仓持仓未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="availableBalance" label="可用下单余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="withdrawAvailable" label="最大可转出余额(最大可提款金额)"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="snapshotTime" label="快照时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'BnBalance',
        components: {},
        data() {
            return {
                cDataList: [],
                bDataList: [],
                bTotal: 0,
                mDataList: [],
                timeArr: [],
                activeName: "PARENT_ACCOUNT_BALANCE",
                cParams: {rebateBeginTime: "", rebateEndTime: ""},
                bParams: {snapshotTime: "", coinType: "", userId: "", page: 1, size: 10},
                sDataList: [],
                dialogVisible: false,
                tParams: {tradeBeginTime: "", tradeEndTime: "", orderId: "", userId: "", symbol: "", page: 1, size: 10},
                tDataList: [],
                tTotal: 0,
                timeArrOne: []
            }
        },
        methods: {
            handleClick(tab, event) {
                if (this.activeName == "PARENT_ACCOUNT_BALANCE") {
                    this.mainAccountBalance();
                } else if (this.activeName == "STATISTICS_RETURNED_COMMISSION") {
                    // this.commissionRebateCount();
                } else if (this.activeName == "CONTRACT_BALANCE_SNAPSHOT") {
                    // this.balanceSnapshot();
                } else if (this.activeName == "CONTRACT_TRADE_DATA") {
                    // this.balanceSnapshotCount();
                }
            },
            commissionRebateCount() {
                if (this.timeArr != null) {
                    if (this.timeArr[0] == undefined || this.timeArr[0] == "") {
                        this.$message.error('请选择开始时间！');
                        return;
                    }
                    if (this.timeArr[0] == undefined || this.timeArr[1] == "") {
                        this.$message.error('请选择结束时间！');
                        return;
                    }
                    this.cParams = {rebateBeginTime: this.timeArr[0], rebateEndTime: this.timeArr[1]};
                } else {
                    this.$message.error('请选择时间！');
                    return;
                }
                api.commissionRebateCount(this.cParams).then(({data}) => {
                    this.cDataList = data;
                });
            },
            mainAccountBalance() {
                api.mainAccountBalance().then(({data}) => {
                    this.mDataList = data;
                });
            },
            balanceSnapshot() {
                if (this.bParams.snapshotTime == null || this.bParams.snapshotTime == "") {
                    this.$message.error('请选择快照时间！');
                    return;
                }
                api.balanceSnapshot(this.bParams).then(({data}) => {
                    this.bDataList = data.records;
                    this.bTotal = data.total;
                });
            },
            balanceSnapshotCount() {
                if (this.bParams.snapshotTime == null || this.bParams.snapshotTime == "") {
                    this.$message.error('请选择快照时间！');
                    return;
                }
                api.balanceSnapshotCount(this.bParams).then(({data}) => {
                    this.sDataList = data;
                    this.dialogVisible = true;
                });
            },
            tradeList() {
            },
            handleSizeChange(val) {
                this.bParams.size = val;
                this.balanceSnapshot();
            },
            handleCurrentChange(val) {
                this.bParams.page = val;
                this.balanceSnapshot();
            },
            handleSizeChangeOne(val) {
                this.tParams.size = val;
                this.tradeList();
            },
            handleCurrentChangeOne(val) {
                this.tParams.page = val;
                this.tradeList();
            },
            exportBalanceSnapshot() {
                if (this.bParams.snapshotTime == null || this.bParams.snapshotTime == "") {
                    this.$message.error('请选择快照时间！');
                    return;
                }
                api.balanceExport(this.bParams).then(response => {
                    const fileName = "合约余额快照导出数据表" + this.bParams.snapshotTime + ".xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            contractTradeData() {
                if (this.timeArrOne != null) {
                    if (this.timeArrOne[0] == undefined || this.timeArrOne[0] == "") {
                        this.$message.error('请选择开始时间！');
                        return;
                    }
                    if (this.timeArrOne[0] == undefined || this.timeArrOne[1] == "") {
                        this.$message.error('请选择结束时间！');
                        return;
                    }
                    this.tParams.tradeBeginTime = this.timeArrOne[0];
                    this.tParams.tradeEndTime = this.timeArrOne[1];
                } else {
                    this.$message.error('请选择时间！');
                    return;
                }
                api.tradeList(this.tParams).then(({data}) => {
                    this.tDataList = data.records;
                    this.tTotal = data.total;
                });
            },
            exportContractTradeData() {
                if (this.timeArrOne != null) {
                    if (this.timeArrOne[0] == undefined || this.timeArrOne[0] == "") {
                        this.$message.error('请选择开始时间！');
                        return;
                    }
                    if (this.timeArrOne[0] == undefined || this.timeArrOne[1] == "") {
                        this.$message.error('请选择结束时间！');
                        return;
                    }
                    this.tParams.tradeBeginTime = this.timeArrOne[0];
                    this.tParams.tradeEndTime = this.timeArrOne[1];
                } else {
                    this.$message.error('请选择时间！');
                    return;
                }
                api.exportTradeList(this.tParams).then(response => {
                    const fileName = "合约交易数据导出数据表" + this.tParams.tradeBeginTime + "-" + this.tParams.tradeEndTime + ".xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            clearData() {
                this.sDataList = [];
            }
        },
        created() {
            this.mainAccountBalance();
        }
    };
</script>

<style lang="less" scoped>

</style>

